import { ChartDataset } from "chart.js";
import { ChartDataSource } from "./chart-datasource.model";

export class BarChartDataSource implements ChartDataSource {
    datasets?: ChartDataset<'bar', number[]>[] = [];
    labels?: string[] = [];
    columnCodes?: string[];

    constructor() {
        this.datasets = [];
        this.labels = [];      
        this.columnCodes = [];
    }
}